import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import styled from 'styled-components';

import ComposerContext from 'components/composer/contexts/composer_context';
import connect from 'components/lib/connect';
import ErrorBoundary from 'components/common/utilities/error_boundary';
import TaskTopicsSelector from 'components/composer/shared/task_topics_selector';

// Second header row in the task composer, holding the task's topics.
//
// Create only: the edit composition has no topicIds to write to, and the feed
// pills are already the editing affordance for a saved task.
export function TaskTopicsRow({ isEditing, isEnabled }) {
  const { composition } = useContext(ComposerContext);

  if (isEditing || !isEnabled) {
    return null;
  }

  return (
    <Row data-aid="taskComposer-topicsRow">
      <ErrorBoundary errorMeta={{ compositionId: composition && composition.id }} renderError={() => null}>
        <TaskTopicsSelector />
      </ErrorBoundary>
    </Row>
  );
}

TaskTopicsRow.propTypes = {
  isEditing: PropTypes.bool,
  isEnabled: PropTypes.bool,
};

const Row = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${p => p.theme.spacing.medium};
  margin-top: ${p => p.theme.spacing.small};
  min-width: 0;
`;

function mapStateToProps({ isFeatureEnabled }) {
  return {
    isEnabled: isFeatureEnabled('conversation:general') && isFeatureEnabled('topicsOnTasks'),
  };
}

export default connect(mapStateToProps)(TaskTopicsRow);
